<template>
  <div class="p-4 flex flex-col items-center space-y-4">
    <v-btn :loading="loading" @click="loginWithLinkedIn"  block style="border-radius: 5px!important; font-size: 0.85rem" class="w-100 social-btn bg-blue d-flex text-white px-4 py-2 rounded-lg">
      <v-icon>mdi-linkedin</v-icon><span class="flex-grow-1">{{$t('auth.loginWithLinkedIn')}}</span>
    </v-btn>
  </div>
</template>

<script>
import {useNotificationStore} from "@/stores/notification.module";
import {useAuthUserStore} from "@/stores/modules/auth.module";
let frontend=process.env.VUE_APP_FRONTHOST;
let linkedInClientId=process.env.VUE_APP_LINKEDIN_CLIENT_ID;
let linkedInClientSecret=process.env.VUE_APP_LINKEDIN_CLIENT_SECRET;
export default {
  setup(){
    const notificationStore = useNotificationStore();
    const authStore = useAuthUserStore();
    return{
      authStore,
      notificationStore
    }
  },
  data() {
    return {
      loading: false,
      clientId: linkedInClientId,
      clientSecret: linkedInClientSecret, // Should be handled on a backend
      redirectUri: frontend+"/login", // Must match LinkedIn settings
      scope: "openid email profile",
      accessToken: null,
      error: null,
    };
  },
  methods: {
    loginWithLinkedIn() {
      window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(
          this.redirectUri
      )}&scope=${encodeURIComponent(this.scope)}`; // Redirect user to LinkedIn OAuth page
    },

    async fetchAccessToken(authCode) {
      this.loading=true;
      try {
        const data = await this.authStore.getLinkedInToken(authCode);
        if(data?.requires_registration_completion){
          this.$emit('registration-required',{token:data.token});
        }
      } catch (err) {
        console.error("Error Response:", err.response ? err.response.data : err.message);
        this.notificationStore.pushSimple(err.response ? err.response.data.error_description : "Unknown error","ERROR");
      }finally {
        this.loading=false;
      }
    }
,

    getAuthCode() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("code");
    },
  },
  mounted() {
    console.log("mounted");

    const authCode = this.getAuthCode();
    console.log("authCode", authCode);
    if (authCode) {
      this.fetchAccessToken(authCode);
    }
  },
};
</script>

<style scoped>
button {
  cursor: pointer;
}
</style>
